import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SDate, SHr, SIcon, SImage, SList, SNavigation, SPage, SPopup, SText, SView } from 'servisofts-component';
import ActionMusculo from './ActionMusculo';
import Container from '../../../../Components/Container';
import SSocket from 'servisofts-socket';
import CrearPublicacion from './crearPublicacion';
import ActionMusculoPublicacion from './ActionMusculoPublicacion';
import Crear from './crear';
import { FlatList } from 'react-native-gesture-handler';
export default class root extends Component {

    static INSTANCE = null;
    pk = SNavigation.getParam("key");
    state = {
        data: null
    }
    componentDidMount() {
        root.INSTANCE = this;

        ActionMusculo.getAllPublicaciones().then((resp) => {
            resp.sort((a, b) => {
                if (a.descripcion > b.descripcion) return 1;
                if (a.descripcion < b.descripcion) return -1;
                return 0;
            })
            resp = resp.filter((item) => {
                return item.key_tutorial_musculo == this.pk;
            })
            this.setState({ data: resp })
        })
    }
    handleCrear() {

        // CrearPublicacion.open({ key_musculo: this.pk });
        CrearPublicacion.open({ key_musculo: this.pk });

    }
    render() {
        return <SPage title={"Tutoriales Musculos"} >
            <Container>
                <SHr />
                <SView col={"xs-12"} row>
                    <SView height={40} width={40} center card onPress={this.handleCrear.bind(this)}>
                        <SIcon name='Add' />
                    </SView>
                    {/* <SText card padding={8} onPress={this.handleCrear.bind(this)}>{"Nuevo musculo"}</SText> */}
                </SView>
                <SHr />
                <FlatList
                    style={{ width: "100%" }}
                    ItemSeparatorComponent={() => <SHr />}
                    data={Object.values(this.state.data ?? {}).sort((a, b) => {
                        return a.index - b.index;
                    })}
                    keyExtractor={(item) => item.key}
                    renderItem={({ item }) => {
                        const obj = item;
                        return (
                            <SView row col={"xs-12"} padding={8} center card>
                                <SView col={"xs-12"} row>
                                    <SView flex height style={{
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        paddingLeft: 8,
                                    }}>
                                        <SText bold fontSize={18}>{obj.descripcion}</SText>
                                    </SView>
                                    <SView height={35} width={40} center card onPress={() => {
                                        CrearPublicacion.open({ data: obj, key_musculo: this.pk, callback: () => { this.componentDidMount(); } })
                                    }}>
                                        <SIcon name='Edit' />
                                    </SView>
                                    <SView width={8} />
                                    <SView height={35} width={40} center card onPress={() => {
                                        SPopup.confirm({
                                            title: "Eliminar Musculo",
                                            message: "¿Estas seguro de eliminar el musculo?",
                                            onPress: () => {
                                                ActionMusculoPublicacion.eliminar(obj.key).then((resp) => {
                                                    this.componentDidMount();
                                                })
                                            }
                                        })
                                    }}>
                                        <SIcon name='Delete' />
                                    </SView>
                                </SView>
                                {/* Agrupa los dos card en un solo SView row */}
                                <SView row style={{ width: "100%", justifyContent: "flex-start" }}>
                                    <SView row>
                                        <SView
                                            style={{
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                marginRight: 45,
                                                left: 30
                                            }}
                                            height={200}
                                            width={140}
                                            center
                                            card
                                        >
                                            <video
                                                src={SSocket.api.root + "tutorial_musculo_publicacion/" + obj.key + ".mp4?time=" + new SDate().getTime()}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 8,
                                                    overflow: "hidden",
                                                }}
                                                controls
                                            />
                                        </SView>
                                        <SView
                                            style={{
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                            }}
                                            height={200}
                                            width={140}
                                            center
                                            card
                                        >
                                            <SImage
                                                src={SSocket.api.root + "tutorial_musculo_publicacion/" + obj.key + "_imagen" + "?time=" + new SDate().getTime()}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 8,
                                                    overflow: "hidden",
                                                }}
                                            />
                                        </SView>
                                    </SView>
                                </SView>
                            </SView>
                        );
                    }}
                />
            </Container>
            {/* <SText>{JSON.stringify(this.state.data)}</SText> */}
        </SPage>
    }
}
